export enum FilterItemLabel {
    PriceRange = 'PRICE RANGE'
}